// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__-s7wo","heroText":"Hero_heroText__w7yrF"};